// extracted by mini-css-extract-plugin
export default {"table":"styles_table__ej2oV","head":"styles_head__rxA0v","body":"styles_body__drHE5"};